module.exports = __webpack_public_path__ + "img/pagging-next.53ab96d5.svg";